import { CheckIcon } from '@heroicons/react/20/solid';

import { Text } from '@northladder/i18n';

import { translations } from '../../../translations';

import { CircularLoader } from '../../loaders';

interface IButtonCaptureImageProps {
  onClick: () => void;
  isProcessing?: boolean;
}

/**
 * -----------------------------------------------------------------------------
 * Renders a button which on press captures the currently previewed image from
 * the camera.
 */
export function ButtonCaptureImage({
  isProcessing = false,
  onClick,
}: IButtonCaptureImageProps) {
  const btnClass = isProcessing ? 'opacity-80' : 'opacity-100';

  return (
    <button
      className={`
        form-btn z-[100] flex w-auto border border-gray-50 px-2
        shadow-lg ${btnClass}
      `}
      disabled={isProcessing}
      onClick={onClick}
      type="button"
    >
      {isProcessing ? (
        <div className="flex items-center gap-2">
          <CircularLoader className="h-4 w-4 px-1 text-white" />
          <Text text={translations.camera.capturing} />
        </div>
      ) : (
        <>
          <CheckIcon className="h-5 px-1 text-white" />
          <Text text={translations.camera.capture} />
        </>
      )}
    </button>
  );
}
